export class NodeDialogElement extends HTMLElement {
    #inertedSiblings = [];
    #previousFocus = null;
    connectedCallback() {
        const activeElement = this.#activeElement();
        this.#previousFocus = activeElement instanceof HTMLElement
            ? activeElement
            : null;
        this.addEventListener("keydown", this.#handleKeyDown);
        this.#makeBackgroundInert();
        this.render();
        queueMicrotask(() => {
            if (this.isConnected)
                this.#focusables()[0]?.focus();
        });
    }
    disconnectedCallback() {
        this.removeEventListener("keydown", this.#handleKeyDown);
        for (const sibling of this.#inertedSiblings.splice(0))
            sibling.inert = false;
        this.#previousFocus?.focus();
        this.#previousFocus = null;
    }
    render() {
        const label = this.getAttribute("label") ?? "Dialog";
        const existing = this.querySelector(":scope > [data-node-dialog]");
        if (existing) {
            existing.setAttribute("aria-label", label);
            return;
        }
        const content = [...this.childNodes];
        const dialog = document.createElement("div");
        dialog.className = "node-dialog";
        dialog.dataset.nodeDialog = "true";
        dialog.setAttribute("aria-label", label);
        dialog.setAttribute("aria-modal", "true");
        dialog.setAttribute("role", "dialog");
        dialog.tabIndex = -1;
        dialog.append(...content);
        this.append(dialog);
    }
    #handleKeyDown = (event) => {
        if (event.key === "Escape") {
            event.preventDefault();
            this.dispatchEvent(new CustomEvent("close", { bubbles: true, composed: true }));
            return;
        }
        if (event.key !== "Tab")
            return;
        const focusables = this.#focusables();
        if (focusables.length === 0)
            return;
        const current = this.#activeElement();
        const first = focusables[0];
        const last = focusables.at(-1);
        if (event.shiftKey && current === first) {
            event.preventDefault();
            last.focus();
        }
        else if (!event.shiftKey && current === last) {
            event.preventDefault();
            first.focus();
        }
    };
    #focusables() {
        const candidates = Array.from(this.querySelectorAll("button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"));
        if (candidates.length > 0)
            return candidates;
        const dialog = this.querySelector("[data-node-dialog]");
        return dialog ? [dialog] : [];
    }
    #activeElement() {
        const root = this.getRootNode();
        return root instanceof ShadowRoot ? root.activeElement : this.ownerDocument.activeElement;
    }
    #makeBackgroundInert() {
        const root = this.getRootNode();
        const siblings = this.parentElement?.children ?? (root instanceof ShadowRoot ? root.children : undefined);
        if (!siblings)
            return;
        for (const sibling of Array.from(siblings)) {
            if (sibling instanceof HTMLElement && sibling !== this && !sibling.inert) {
                sibling.inert = true;
                this.#inertedSiblings.push(sibling);
            }
        }
    }
}
//# sourceMappingURL=node-dialog.js.map